module.exports = __webpack_public_path__ + "img/instruction4.438fd8c9.jpg";